import styled, { CSSObject } from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'

const DeliveryPin = ({ pincode }: { pincode: string }) => {
  return (
    <Root>
      <Pin>{pincode}</Pin>
      <Instruction>
        You will need to provide this code to receive your order.
      </Instruction>
    </Root>
  )
}

const Root = styled.div<StyledHTMLElement>(
  ({ theme }): CSSObject => ({
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    padding: '12px',
    borderRadius: theme.borderRadius
  })
)

const Pin = styled.p<StyledHTMLElement>(
  ({ theme }): CSSObject => ({
    display: 'block',
    margin: '0',
    padding: '12px 6px 12px 12px',
    borderRadius: theme.borderRadius,
    backgroundColor: '#262626',
    textAlign: 'center',
    color: '#fff',
    fontWeight: 700,
    fontSize: '18px',
    letterSpacing: '6px'
  })
)

const Instruction = styled.p<StyledHTMLElement>(
  (): CSSObject => ({
    margin: '0',
    color: '#262626',
    fontWeight: 700,
    fontSize: '16px'
  })
)

export default DeliveryPin
